import { ThemeConfig } from 'antd';

const themeConfig: ThemeConfig = {
    token: {
        colorPrimary: '#2D60FF', // 修改主色
        colorLink: '#2D60FF',     // 修改超链接颜色
    },
};

export default themeConfig;
